import React, { useState, useEffect } from 'react';
import {
  ChevronRight,
} from 'lucide-react';
import './ReadyStockServices.css';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useSeller } from '../contexts/SellerContext';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../services/firebase';
import { useNavigate } from 'react-router-dom';

const OrderServe = () => {
  const { seller } = useSeller();
  const sellerId = seller?.sellerId;
  const navigate = useNavigate();
  const serviceType = 'order';
  const [orderCounts, setOrderCounts] = useState({
    requested: 0,
    Preparation: 0,
    Processing: 0,
  });
  const [loading, setLoading] = useState(true);

  // Fetch and count orders by status
  useEffect(() => {
    const fetchOrderCounts = async () => {
      if (!sellerId) return;

      try {
        setLoading(true);
        const q = query(collection(db, 'orderList'), where('sellerId', '==', sellerId), where('serviceType', '==', 'order'));
        const snapshot = await getDocs(q);

        const counts = {
          requested: 0,
          Preparation: 0,
          Processing:0
        };

        snapshot.forEach((doc) => {
          const data = doc.data();
          const status = data.orderStatus;

          switch (status) {
            case 'Requested':
              counts.requested += 1;
              break;
            case 'Preparation':
              counts.Preparation += 1;
              break;
            case 'Processing':
              counts.Processing += 1;
              break;
            default:
              break;
          }
        });

        setOrderCounts(counts);
      } catch (error) {
        console.error('Error fetching order counts:', error);
        // Optionally show toast or fallback counts
      } finally {
        setLoading(false);
      }
    };

    fetchOrderCounts();
  }, [sellerId]);

  const totalOrders = Object.values(orderCounts).reduce((sum, count) => sum + count, 0);

  // Workflow Steps (now dynamic)
  const steps = [
    {
      id: 1,
      title: 'Buyer Requests',
      subtitle: 'New incoming enquiries',
      count: orderCounts.requested,
      color: 'yellow',
      path: '/buyerrequest',
    },
    {
      id: 2,
      title: 'Preparation',
      subtitle: 'Start order preparation',
      count: orderCounts.Preparation,
      color: 'blue',
      path: '/preparation',
    },
    {
      id: 3,
      title: 'Processing',
      subtitle: 'Confirm specs & edits',
      count: orderCounts.Processing,
      color: 'orange',
      path: '/processing',
    }
  ];

  if (loading) {
    return (
      <>
        <Header title="Order Services" />
        <div className="overview-container">
          <div className="overview-card">
            <h2 className="overview-title">Loading...</h2>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header title="Order Services" />

      {/* Overview Stats */}
      <div className="overview-container">
        <div className="overview-card">
          <h2 className="overview-title">Today's Overview</h2>
          <div className="overview-stats">
            <div className="stat-item">
              <div className="stat-value">{totalOrders}</div>
              <div className="stat-label">Total Orders</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">{orderCounts.Preparation}</div>
              <div className="stat-label">Preparation</div>
            </div>
            <div className="stat-item">
              <div className="stat-value">{orderCounts.Processing}</div>
              <div className="stat-label">Processing</div>
            </div>
          </div>
        </div>
      </div>

      {/* Workflow Steps */}
      <div className="serve-container">
        <div className="workflow-steps">
          {steps.map((step, index) => (
            <div key={step.id} className={`step-card ${step.color}`} onClick={() => {
              navigate(step.path, { state: { serviceType } });
            }}>
              <div className="readystep-content">
                <div className={`step-number ${step.color}`}>{step.id}</div>
                <div className="step-details">
                  <h3 className="workstep-title">{step.title}</h3>
                  <p className="step-subtitle">{step.subtitle}</p>
                </div>
                <div className="step-count">
                  <span>{step.count}</span>
                  <span className="arrow"><ChevronRight /></span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </>
  );
};

export default OrderServe;